export const Utils = {
  groupBy,
  downloadFileFromBlob,
};

function groupBy(list, keyGetter) {
  //console.log("Groupby...");
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    if (key) {
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    }
  });
  //console.log("Groupby...", map);
  return map;
}

function downloadFileFromBlob(data, fileName) {
  try {
    const blob = data instanceof Blob ? data : new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName || `download_${Date.now()}`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (e) {
    // swallow; caller may handle UI feedback
  }
}
